import { Box, Typography, Button } from '@mui/material';
// import { Link } from 'react-router-dom';
import homepage from '../assets/homepage.webp';
const zocdocLink =
  'https://www.zocdoc.com/practice/aspire-bhp-179924?lock=true&isNewPatient=false&referrerType=widget';
export default function HeroSection() {
  return (
    <>
      {/* Fixed Background for Parallax Effect */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100vh',
          backgroundImage: `url(${homepage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: {
            xs: 'center top',
            sm: 'center center',
            md: 'center center',
          },
          zIndex: -2,
        }}
      />

      {/* Hero Section */}
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          maxWidth: '100vw',
          minHeight: {
            xs: 520,
            sm: 580,
            md: 650,
            lg: 620,
          },
          py: {
            xs: 8,
            sm: 10,
            md: 12,
            lg: 10,
          },
          overflow: 'hidden',
          boxSizing: 'border-box',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          color: 'white',
        }}
      >
        {/* Dark overlay */}
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(0,0,0,0.45)',
            zIndex: 1,
          }}
        />

        {/* Hero Content */}
        <Box
          sx={{
            position: 'relative',
            zIndex: 2,
            px: { xs: 2, sm: 3 },
            width: '100%',
            maxWidth: { xs: '92%', sm: '75%', md: '700px' },
            boxSizing: 'border-box',
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontWeight: 600,
              mb: 2,
              lineHeight: 1.2,
              fontSize: {
                xs: '2rem',
                sm: '2.5rem',
                md: '3rem',
                lg: '3.5rem',
              },
            }}
          >
            Compassionate Mental Health Care
          </Typography>

          <Typography
            variant="h6"
            sx={{
              fontWeight: 300,
              lineHeight: 1.8,
              mb: 4,
              fontSize: {
                xs: '1rem',
                sm: '1.1rem',
                md: '1.2rem',
              },
            }}
          >
            Personalized psychiatric care designed to help you feel supported,
            understood, and empowered through every step of your mental health
            journey.
          </Typography>

          <Box
            sx={{
              display: 'flex',
              gap: 2,
              justifyContent: 'center',
              flexWrap: 'wrap',
              width: '100%',
            }}
          >
            <Button
              variant="contained"
              href="tel:2108669850"
              sx={{
                backgroundColor: '#e3f3c5',
                color: 'black',
                fontWeight: 600,
                px: 4,
                py: 1.3,
                borderRadius: '30px',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#d3eab0',
                },
              }}
            >
              Call 210-866-9850
            </Button>

            <Button
                          component="a"
                          href={zocdocLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          variant="outlined"
                          sx={{
                            borderColor: 'white',
                            color: 'white !important',
                            fontWeight: 600,
                            px: 4,
                            py: 1.3,
                            borderRadius: '30px',
                            textTransform: 'none',
                            '&:visited': {
                              color: 'white',
                            },
                            '&:hover': {
                              borderColor: 'white',
                              backgroundColor: 'rgba(255,255,255,0.1)',
                              color: 'white',
                            },
                          }}
                        >
                          Schedule an Appointment
                        </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}